import logger from './logger';

// Utility that clears the redux-persist state held in localStorage.
export const clearPersistedStorage = () => {
  try {
    // Drop every persist: entry in localStorage
    const keys = Object.keys(localStorage);
    keys.forEach(key => {
      if (key.startsWith('persist:')) {
        localStorage.removeItem(key);
      }
    });

    logger.info('✅ Persisted storage cleared successfully');
    logger.info('🔄 Please refresh the page to reinitialize the store');

    return true;
  } catch (error) {
    console.error('❌ Error clearing persisted storage:', error);
    return false;
  }
};

// Note: a version-keyed blanket wipe lived here once. Nothing replaced it,
// because persisted client state (last workspace, filters) is meant to survive
// deploys. Quota pressure is held down instead by the per-slice blacklists in
// rootReducer.js, and a write that fails anyway is logged per slice by the
// `writeFailHandler` that `persistEach` attaches there.
// `clearPersistedStorage` stays as a manual escape hatch.

// In development the function is exposed on window so the store can be cleared
// from the browser console.
if (import.meta.env.VITE_ENVIRONMENT === 'development' || import.meta.env.VITE_ENVIRONMENT === 'dev') {
  window.clearPersistedStorage = clearPersistedStorage;
  logger.debug('🛠️ Development mode: clearPersistedStorage() available in console');
}
